export default "__VITE_ASSET__4881b10f__"